import React, { useMemo, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { sendInventorySummaryMail } from '../../../../api/inventoryCountingApi';

function formatDateInput(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function getDefaultRange() {
  const now = new Date();
  const from = new Date(now.getFullYear(), now.getMonth(), 1);
  return {
    from: formatDateInput(from),
    to: formatDateInput(now),
  };
}

function parseRecipients(value) {
  return value
    .split(/[;,]/)
    .map((x) => x.trim())
    .filter(Boolean);
}

export default function SummaryMailPanel() {
  const defaultRange = useMemo(() => getDefaultRange(), []);

  const [from, setFrom] = useState(defaultRange.from);
  const [to, setTo] = useState(defaultRange.to);
  const [recipients, setRecipients] = useState('');
  const [dashboardUrl, setDashboardUrl] = useState(
    `${window.location.origin}/inventory-counting`,
  );
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSend = async () => {
    const recipientsArray = parseRecipients(recipients);

    if (!from || !to) {
      setError('Uzupełnij zakres dat.');
      return;
    }

    // if (!recipientsArray.length) {
    //   setError('Podaj przynajmniej jednego odbiorcę.');
    //   return;
    // }

    setSending(true);
    setMessage(null);
    setError(null);

    try {
      const result = await sendInventorySummaryMail({
        from,
        to,
        // recipients: recipientsArray,
        dashboardUrl,
      });

      setMessage(result?.message || `Mail został wysłany.`);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          'Nie udało się wysłać maila z podsumowaniem.',
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <Card variant="outlined" sx={{ mt: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Wyślij podsumowanie mailem
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Mail zawiera magazyn, okres raportu, KPI, raport narastający oraz link
          do dashboardu.
        </Typography>

        {message && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {message}
          </Alert>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Stack spacing={2}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              size="small"
              label="Od"
              type="date"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />

            <TextField
              size="small"
              label="Do"
              type="date"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Stack>

          {/* <TextField
            size="small"
            label="Odbiorcy"
            placeholder="mail1@firma.pl; mail2@firma.pl"
            value={recipients}
            onChange={(e) => setRecipients(e.target.value)}
            helperText="Oddziel adresy średnikiem lub przecinkiem."
            fullWidth
          />

          <TextField
            size="small"
            label="Link do dashboardu"
            value={dashboardUrl}
            onChange={(e) => setDashboardUrl(e.target.value)}
            fullWidth
          /> */}

          <Box>
            <Button
              variant="contained"
              startIcon={<SendIcon />}
              onClick={handleSend}
              disabled={sending}
            >
              {sending ? 'Wysyłanie...' : 'Wyślij podsumowanie'}
            </Button>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
